export default {
  INIT: 'MERCHANT/INIT',
  GET_MERCHANT: 'MERCHANT/GET_MERCHANT',
  SELECT_TABLE_GROUP: 'MERCHANT/SELECT_TABLE_GROUP',
  GET_CUSTOM_REASON: 'MERCHANT/GET_CUSTOM_REASON',
};
